import { render, staticRenderFns } from "./WeboaDashboard.vue?vue&type=template&id=371a6d6e&"
import script from "./WeboaDashboard.vue?vue&type=script&lang=js&"
export * from "./WeboaDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports